// TODO: SPT:REMOVE

import { createReducer } from '@/redux/root';

import {
  nameSpace,
  //requestAreaAsync,
  requestAreasAsync,
  requestAreaMapAsync, requestAreasListAsync,
} from './actions';
import { logoutAction } from '@/redux/auth';

const initialState = {
  areas: [],
  areasTotal: 0,
  areaMap: null,
  areasList: [],
};

export const areasReducer = createReducer(nameSpace, initialState, {
  [requestAreasAsync.success]: ({ state, action }) => {
    state.areas = action.payload.data?.data;
    state.areasTotal = action.payload.data?.total;
  },
  [requestAreaMapAsync.success]: ({ state, action }) => {
    state.areaMap = action.payload;
  },
  [requestAreasListAsync.success]: ({ state, action }) => {
    const { areas } = action.payload;

    state.areasList = areas;
  },
  [logoutAction]: ({ state }) => {
    state.areasList = [];
  },
});
